var DataCacheEntry = /** @class */ (function () {
    function DataCacheEntry(dataSource, lifeTimeMinutes) {
        this.dataSource = dataSource;
        this.lifeTimeMinutes = lifeTimeMinutes;
        this.expiryDate = new Date();
    }
    Object.defineProperty(DataCacheEntry.prototype, "isExpired", {
        get: function () {
            return Date.now() >= this.expiryDate.getTime();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataCacheEntry.prototype, "willLoad", {
        get: function () {
            return this.dataSource.willLoad || this.isExpired;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataCacheEntry.prototype, "currentData", {
        /**
         * Returns the latest fetched data, or default if the data has never been fetched.
         * Will not re-fetch if the lifetime has been exceeded.
         */
        get: function () {
            return this.dataSource.data;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Gets an api datasource which was previously registered. Datasource will re-fetch its data if the data lifetime has been exceeded.
     */
    DataCacheEntry.prototype.get = function (clearPreviousError) {
        if (clearPreviousError === void 0) { clearPreviousError = false; }
        this.fetchIfExpired(clearPreviousError);
        return this.dataSource;
    };
    /**
     * Returns a promise from which data can be obtained. Data will be re-fetched if the lifetime has been exceeded.
     */
    DataCacheEntry.prototype.getDataAsync = function () {
        return this.get(true).promise;
    };
    /**
     * Expires the datasource.
     * @param refetch True if the datasource must be refetched. This will cause any consumers of this datasource to rebind to the updated data.
     */
    DataCacheEntry.prototype.expire = function (refetch) {
        if (refetch === void 0) { refetch = false; }
        this.expireNow();
        if (refetch) {
            this.fetchIfExpired();
        }
    };
    DataCacheEntry.prototype.expireNow = function () {
        this.expiryDate = new Date();
    };
    DataCacheEntry.prototype.fetchIfExpired = function (clearPreviousError) {
        var _this = this;
        if (clearPreviousError === void 0) { clearPreviousError = false; }
        if (this.isExpired) {
            this.expiryDate = new Date();
            this.expiryDate.setMinutes(this.expiryDate.getMinutes() + this.lifeTimeMinutes);
            this.dataSource.fetchDataAsync(clearPreviousError).catch(function (e) {
                _this.expireNow();
                // TODO: Error handling, or is console logging enough?
            });
        }
    };
    return DataCacheEntry;
}());
export { DataCacheEntry };
